import { useEffect } from "react";
import useStore from "@/store/store";

/**
 * 근무표 생성 중(pending)일 때 브라우저 새로고침 및 닫기를 방지하는 커스텀 훅
 */
export default function useRosterPreventRefresh() {
  const rosterStatus = useStore((state) => state.rosterMade.status);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (rosterStatus === "pending") {
        e.preventDefault();
        e.returnValue = ""; // Chrome에서 경고창을 띄우기 위해 필요
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [rosterStatus]);
}
